<script>
import Layout from '@layouts/empty'

export default {
  metaInfo: {
    title: 'Allbuilds | Not found 404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  methods: {
    goIndex () {
      location.href = '/'
    }
  }
}
</script>

<template>
  <Layout>
    <h1 :class="$style.title">
      404
      <template v-if="resource">
        {{ resource }}
      </template>
      Not Found
    </h1>
    <VFlex class="text-xs-center">
      <v-btn depressed
             color="primary"
             @click="goIndex">
        на главную
      </v-btn>
    </VFlex>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
